import logo from './compasswithtext.png';
import './App.css';
import React, { useEffect, useState, Fragment } from 'react';
//import GetData from './Sheets';
import Papa from "papaparse";
import { createStore } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used

//<FontAwesomeIcon icon={solid('user-secret')} />
//<FontAwesomeIcon icon={regular('user')} />
//<FontAwesomeIcon icon={regular('star')} />
//<FontAwesomeIcon icon={solid('star')} />


//KEYS
const TOOL = 1;
const TITLE = 2;
const TYPE = 5;
const SCALE = 6;
const PURPOSE = 7;
const EM = 8;
const DATATYPE = 9;
const INSTRUMENT = 10;
const VALIDITY = 11;
const POPULATION = 12;
const GRPSIZE = 13;
const PREP = 14;
const DATACOMPLEX = 15;
const EXPERTISE = 16;
const OUTCOME = 17;
const ABET = 18;

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

const selectAction = (state, action) => {
    if (typeof state === 'undefined') {
        return {selections:[],data:[]}
    }
    if (action.type === 'DATA')
    {
        state.data = action.data
        return state
    }
    if (action.id === 'Clear Last Selection') {
        state.selections.pop();
        return state;
    }
    const s = action.id;
    state.selections.push(s);
    
    
    return state;
}
let uniqueKey = 0;
export const store = createStore(selectAction);

store.subscribe(() => {
    const storeNow = store.getState()
    console.log(storeNow)
})

const rubric = <span class="hovertext" data-hover="Rubric"><FontAwesomeIcon icon={solid('list')} /></span>;
const survey = <span class="hovertext" data-hover="Survey"><FontAwesomeIcon icon={solid('pen-to-square')} /></span>;
const concept = <span class="hovertext" data-hover="Concept Inventory"><FontAwesomeIcon icon={solid('chart-column')} /></span>;
const self = <span class="hovertext" data-hover="Self-Assessment"><FontAwesomeIcon icon={solid('hand-point-up')} /></span>;
const map = <span class="hovertext" data-hover="Concept Map"><FontAwesomeIcon icon={solid('map')} /></span>;
const peer = <span class="hovertext" data-hover="Peer Assessment"><FontAwesomeIcon icon={solid('people-group')} /></span>;
const reflection = <span class="hovertext" data-hover="Reflection"><FontAwesomeIcon icon={solid('comment')} /></span>;
const test = <span class="hovertext" data-hover="Test/Exam"><FontAwesomeIcon icon={solid('calculator')} /></span>;
const artifacts = <span class="hovertext" data-hover="Artifacts"><FontAwesomeIcon icon={solid('folder-open')} /></span>;
const interview = <span class="hovertext" data-hover="Interview"><FontAwesomeIcon icon={solid('clipboard-question')} /></span>;

const prepHigh = <span class="hovertext" data-hover="More than 2 hrs prep time."><FontAwesomeIcon icon={solid('gauge-high')} /></span>;
const simple = <span class="hovertext" data-hover="Simple to implement."><FontAwesomeIcon icon={solid('battery-empty')} /></span>;
//<FontAwesomeIcon icon={solid('battery-quarter')} />
const moderate = <span class="hovertext" data-hover="Moderate"><FontAwesomeIcon icon={solid('battery-half')} /></span>;
//<FontAwesomeIcon icon={solid('battery-three-quarters')} />
const complex = <span class="hovertext" data-hover="Complex"><FontAwesomeIcon icon={solid('battery-full')} /></span>;
const exemplar = <span class="hovertext" data-hover="Exemplar"><FontAwesomeIcon icon={solid('gem')}  /> </span>;
const check = <span class="hovertext" data-hover="Yes, partial, or potential"><FontAwesomeIcon icon={solid('check')} /></span>;

function getInstruments(list)
{
    
    let ret = [];
    for(let i=0;i<list.length;i++)
    {
        switch(list[i]){
            case "Survey": ret.push(survey);ret.push(" ");break;
            case "Concept Inventory": ret.push(concept);ret.push(" ");break;
            case "Rubric": ret.push(rubric);ret.push(" ");break;
            case "Self-Assessment": ret.push(self);ret.push(" ");break;
            case "Concept Map": ret.push(map);ret.push(" ");break;
            default: break;
        }
    }
    return ret;
}

function Page() {
    const selections = store.getState().selections;
    const data = store.getState().data;
    const keyOrder = [1,5,8,9];
    const keyIndex = selections.length;
    let keys;
    if(data.length > 0)
        keys = Object.keys(store.getState().data[0]);
    const splits = {1:", ",5:"), ",6:"), ",7:", ",8:", ",10:", ",12:", ",17:"), "}
    
    let buttons = [];
    let clearfilter = "";
    if((typeof keys === 'undefined') || selections.length < 1)
    {
        const resourceTypes = ["Tool", "Faculty Development", "Learning Outcomes", "Program Assessment"];
        for(let i=0;i < resourceTypes.length; i++)
        {
            buttons.push( <ChoiceButton text={resourceTypes[i]} key={uniqueKey++}/> );
        }
    }
    else
    {
        let options = [];
        if(keyIndex < keyOrder.length)
        {
            const theKey = keys[keyOrder[keyIndex]];
            //console.log("theKey", theKey);
            for(let i=0; i<data.length; i++)
            {
                if(keyOrder[keyIndex] in splits)
                {
                    const strings = data[i][theKey].split(splits[keyOrder[keyIndex]]);
                    for(let j=0; j<strings.length;j++)
                    {
                        if (!options.includes(strings[j])) {
                            options.push(strings[j]);
                            //console.log("adding", strings[j]);
                        }
                    }
                }
                else
                {
                    
                    if (!options.includes(data[i][theKey]))
                    {
                        options.push(data[i][theKey]);
                        //console.log("adding", data[i][theKey]);
                    }
                }
                
            }
            if(keyOrder[keyIndex] === 5)
                options.shift();
            
            for(let i=0; i<options.length; i++)
            {
                buttons.push( <td><ChoiceButton text={options[i]} key={uniqueKey++}/></td> );
                //WARNING they mean it about a unique key, this is a silly
                // calculation to make the ids unique
                //(keyIndex+1)*10+i
            }
        }
        //buttons.push( <td><ChoiceButton text="Go Back" key={-1}/></td> );
        clearfilter = <td><ChoiceButton text="Clear Last Selection" key={-1}/></td>;
    }
    
    //console.log("all buttons", buttons);
    
    let instructions = "";//No more choices";
    if(keyIndex < keyOrder.length && !(typeof keys === 'undefined'))
    {
        const ins_text = keys[keyOrder[keyIndex]].split("(");
        instructions = " Filter on: " + ins_text[0];
    }
    
    
    let results = [];
    for(let i=0;i<data.length; i++)
    {
        let match = true;
        for(let j=0; j<selections.length; j++)
        {
            //console.log(keyOrder[j], j, selections[j])
            if(keyOrder[j] in splits)
            {
                //console.log(data[i][keys[keyOrder[j]]])
                const strings = data[i][keys[keyOrder[j]]].split(splits[keyOrder[j]]);
                let any = false;
                for(let k=0; k<strings.length;k++)
                {
                    //console.log("comparing", strings[k],selections[j])
                    if(strings[k] === selections[j])
                    {
                        any = true;
                    }
                }
                if(!any)
                {
                    match = false;
                }
            }
            else if(! (data[i][keys[keyOrder[j]]] === selections[j]) )
            {
                match = false;
            }
        }
        if(match)
        {
            //create result
            results.push(data[i]);
        }
    }
    
    const link = (val) => {if(val)
         return (<a href={val} target="_blank">
                Visit!</a>);} ;
    
    shuffle(results);
    results.sort(function(a, b){
      if (a[keys[23]]==="Yes" && b[keys[23]]!=="Yes") {return -1;}
      if (a[keys[23]]!=="Yes" && b[keys[23]]==="Yes") {return 1;}
      return 0;
    });
    
    
    
    let prelist=(
                 <tr class="headerrow">
                 <td align="center">Resource</td>
                 <td>Instrument Type(s)</td>
                 <td>High Prep Time?</td>
                 <td>Ease to Implement</td>
                 <td>ABET Aligned?</td>
                 <td>Validated?</td>
                 <td>More Info</td>
                 <td>Materials</td>
                 </tr>);
    let list = results.map((item, i) => (
     <tr key={uniqueKey++}>
     <td align="left">{item[keys[23]]==="Yes"?exemplar:""}
         <span class="title">{item[keys[2]]} <span>{item[keys[23]]==="Yes"?exemplar:""}</span></span><br/>
     <span class="blurb">{item[keys[22]]}
     </span></td>
     <td>{getInstruments(item[keys[10]].split(", "))}</td>
     <td>{item[keys[14]]==="High (2+ hours)"?prepHigh:""}</td>
     <td>{item[keys[16]].split(":")[0]==="Simple"?simple:item[keys[16]].split(":")[0]==="Moderate"?moderate:complex}</td>
     <td>{(item[keys[18]]==="Explicitly aligned to ABET" ||item[keys[18]]==="Has potential to align to ABET") ?check:""}</td>
     <td>{(item[keys[11]]==="Some evidence of validity" ||item[keys[11]]==="Yes - This instrument/tool has evidence of the validity of the instrument either through peer-reviewed publication OR some other effort by the research team") ?check:""}</td>
     <td>{link(item[keys[20]])}</td>
     <td>{link(item[keys[19]])}</td>
     </tr>
     ));
    
    if(results.length < 1)
    {
        list = (<>
                <p class="NoResults"><FontAwesomeIcon icon={solid('face-surprise')} /> No results</p></>);
        prelist = "";
    }
    

    let tabs ;
    if(selections.length >0)
        tabs = ["Results have been filtered by: "];
    else
    {
        tabs = [""];
        list = (<>
                <p class="NoResults">Select a <FontAwesomeIcon icon={solid('filter')} /> filter above to see results!</p></>);
        prelist = "";
    }
    const arrow = <FontAwesomeIcon icon={solid('arrow-right-long')} />;
    for(let ki = 0; ki < selections.length; ki++)
    {
        tabs.push(arrow);
        const strs = selections[ki].split("(");
        tabs.push(" "+ strs[0]+" ");
    }
    
    //const icon = <FontAwesomeIcon icon={regular('face-surpise')} />;
    const filterIcon = <FontAwesomeIcon icon={solid('filter')} />;
    return (
            <>
            <p><b>
            {filterIcon}
            {instructions}
            </b></p>
            <table width="90%"><tr>
            {buttons}
            </tr>
            </table>
            <br/>
            <em>{tabs}</em>{clearfilter}
            <br/>
            <table class="Results" border="1" width="90%" cellpadding="5">
            {prelist}
            {list}
            </table>
            <br/>
            
            </>
            );
}

function App() {
    //const [data, setData] = useState([]);
    //const [keys, setKeys] = useState([]);
    
    useEffect(() => {
        Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vSlweFZu3WBDwm2syGIa0a1dim7sCoBsylU0Jg6gc0zJ_nyQw6FtmdUFWjMW2ZH4c90IQRmgVtnistq/pub?output=tsv', {
        delimiter:'\t',
        quoteChar: '\'',
        escapeChar: '\\',
        download: true,
        header: true,
        preview:0,//for testing, set 0 or remove for deployment
        complete: function(results) {
            var theData = results.data
            //console.log(data[0])
            //console.log(data[1])
            //setData(theData);
            //console.log(Object.keys(data[0]))
            //setKeys(Object.keys(theData[0]))
            store.dispatch({ type:"DATA", data:theData })
        }
        });
    }, []);
    
    return (
            
            <div className="App">
            <header className="App-header">
            <table border="0" cellspacing="20">
            <tr><td>
            <img src={logo} className="App-logo" alt="logo" />
            </td><td class="instructions" align="left">
            Welcome to the COMPASS Navigator tool. This tool aims to help users identify tools that have been used in assessing Entrepreneurial Mindset. To learn more about  our work, please visit our Engineering Unleashed card <a href="https://engineeringunleashed.com/card/3912">here</a>.
            <br/>
            <br/>
            <b>How to use this tool: You will need to select a small number of filters to reduce the results.  Don't be afraid to clear your selection and go back! </b><br/><br/>
            <i>Tip: After selecting at least one filter, try "Control"+"F" to search for names of specific assessment tools you are looking for.</i>
            <br/>
            <br/>To learn more about each category click <a href="https://docs.google.com/document/d/1mBkZ0qFzF-3KcRP7s7e9Csn-aQ0vEbPB7SZ8pGLsmsk/edit"
            target="_blank"
            rel="noopener noreferrer"
            >here</a>.
            
            
            </td></tr>
            </table>
            
            <b><u class="key">Icon Key:</u></b>
            <table class="key" border="0" cellspacing="15">
            <tr>
            <td>{self}</td>
            <td>Self-Assessment</td>
            <td>{survey}</td>
            <td>Survey</td>
            <td>{map}</td>
            <td>Concept Map</td>
            <td>{peer}</td>
            <td>Peer Assessment</td>
            <td>{test}</td>
            <td>Test</td>
            </tr>
            <tr>
            <td>{concept}</td>
            <td>Concept Inventory</td>
            <td>{rubric}</td>
            <td>Rubric</td>
            <td>{reflection}</td>
            <td>Reflection</td>
            <td>{interview}</td>
            <td>Interview</td>
            <td>{artifacts}</td>
            <td>Artifacts</td>
            </tr>
            <tr>
            <td>{exemplar}</td>
            <td><b>Exemplar</b></td>
            <td>{simple}</td>
            <td>Simple implementation</td>
            <td>{moderate}</td>
            <td>Moderate implementation</td>
            <td>{complex}</td>
            <td>Complex implementation</td>
            <td>{prepHigh}</td>
            <td>Prep Time over 2 hours</td>
            </tr>
            </table>
            
            {Page()}
            
            This project uses work shared by the Entrepreneurial Engineering Network (KEEN).
            <a
            className="App-link"
            href="https://engineeringunleashed.com/what-is-keen"
            target="_blank"
            rel="noopener noreferrer"
            >
            Learn more about KEEN.
            </a>
            </header>
            </div>
            );
}

class ChoiceButton extends React.Component {
    constructor(props)
    {
        super(props);
        this.text = props.text;
        //console.log("created: ", props.text);
    }
    
    handleClick() {
        //console.log('You clicked:', this.text);
        store.dispatch({ id: this.text, type:"CLICK" })
    }
    
    render() {
        // This syntax ensures `this` is bound within handleClick
        return (      <button class="ChoiceButton" onClick={() => this.handleClick()}>        {this.text}
                </button>
                );
    }
}

export default App;
